class NSSSRecentPurchases extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    const maximumItems = Math.max(1, Number(this.dataset.maximumItems) || 8);
    this.cards = Array.from(this.querySelectorAll('[data-recent-purchase-card]'))
      .sort((left, right) => Number(right.dataset.purchasedAt) - Number(left.dataset.purchasedAt))
      .slice(0, maximumItems);
    if (!this.cards.length || this.wasDismissed()) return;

    if (this.dataset.mobileEnabled !== 'true' && window.matchMedia('(max-width: 749px)').matches) return;

    this.index = this.getNextCardIndex();
    this.shown = 0;
    this.maximum = Math.max(1, Number(this.dataset.maximum) || 1);
    this.visibleFor = Math.max(4, Number(this.dataset.visibleFor) || 7) * 1000;
    this.interval = Math.max(60, Number(this.dataset.interval) || 60) * 1000;
    this.initialDelay = Math.max(3, Number(this.dataset.initialDelay) || 9) * 1000;
    this.hideTimer = null;
    this.nextTimer = null;

    this.querySelectorAll('[data-recent-purchase-close]').forEach((button) => {
      button.addEventListener('click', () => this.dismiss());
    });

    this.nextTimer = window.setTimeout(
      () => this.showNext(),
      Math.max(this.initialDelay, this.getRateLimitDelay()),
    );
  }

  getStoredValue(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (_error) {
      return null;
    }
  }

  setStoredValue(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (_error) {
      // The rotation still works within the current page when storage is unavailable.
    }
  }

  getRateLimitDelay() {
    const lastShownAt = Number(this.getStoredValue('nsss-recent-purchases-last-shown-at')) || 0;
    return Math.max(0, 60000 - (Date.now() - lastShownAt));
  }

  getNextCardIndex() {
    const lastPurchaseId = this.getStoredValue('nsss-recent-purchases-last-purchase-id');
    const lastIndex = this.cards.findIndex((card) => card.dataset.purchasedAt === lastPurchaseId);
    return lastIndex >= 0 ? (lastIndex + 1) % this.cards.length : 0;
  }

  wasDismissed() {
    try {
      return window.sessionStorage.getItem('nsss-recent-purchases-dismissed') === 'true';
    } catch (_error) {
      return false;
    }
  }

  dismiss() {
    window.clearTimeout(this.hideTimer);
    window.clearTimeout(this.nextTimer);
    this.hideCurrent(true);
    try {
      window.sessionStorage.setItem('nsss-recent-purchases-dismissed', 'true');
    } catch (_error) {
      // The close control still works when storage is unavailable.
    }
  }

  showNext() {
    if (document.hidden || this.shown >= this.maximum) return;

    const rateLimitDelay = this.getRateLimitDelay();
    if (rateLimitDelay > 0) {
      this.nextTimer = window.setTimeout(() => this.showNext(), rateLimitDelay);
      return;
    }

    const lastPurchaseId = this.getStoredValue('nsss-recent-purchases-last-purchase-id');
    let card = this.cards[this.index % this.cards.length];
    if (this.cards.length > 1 && card.dataset.purchasedAt === lastPurchaseId) {
      this.index = (this.index + 1) % this.cards.length;
      card = this.cards[this.index];
    }

    this.cards.forEach((item) => {
      item.classList.remove('is-visible');
      item.setAttribute('aria-hidden', 'true');
    });

    this.hidden = false;
    card.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(() => card.classList.add('is-visible'));

    this.setStoredValue('nsss-recent-purchases-last-shown-at', String(Date.now()));
    this.setStoredValue('nsss-recent-purchases-last-purchase-id', card.dataset.purchasedAt);

    this.index = (this.index + 1) % this.cards.length;
    this.shown += 1;
    this.hideTimer = window.setTimeout(() => this.hideCurrent(false), this.visibleFor);
  }

  hideCurrent(dismissed) {
    const card = this.querySelector('[data-recent-purchase-card][aria-hidden="false"]');
    if (!card) {
      this.hidden = true;
      return;
    }

    card.classList.remove('is-visible');
    window.setTimeout(() => {
      card.setAttribute('aria-hidden', 'true');
      this.hidden = true;
      if (!dismissed && this.shown < this.maximum) {
        this.nextTimer = window.setTimeout(() => this.showNext(), this.interval);
      }
    }, 200);
  }
}

if (!customElements.get('nsss-recent-purchases')) {
  customElements.define('nsss-recent-purchases', NSSSRecentPurchases);
}
